import axios from '~/clients/axios';
import { NEW_CAR_CUSTOMIZE } from '~/constants/endpoints';
import type CustomizeRequest from '~/contracts/new-cars/CustomizeRequest';
import type CustomizeResponse from '~/contracts/new-cars/CustomizeResponse';
import pickRequestProps from '~/utilities/new-cars/pickRequestProps';

export default function fetchCustomizeOptions(
  request: CustomizeRequest,
  controller: AbortController
): Promise<CustomizeResponse> {
  return axios
    .post(NEW_CAR_CUSTOMIZE, pickRequestProps(request), {
      signal: controller.signal
    })
    .then(res => res.data);
}
